import { render } from "./modal-bottom.html?vue&type=template&id=3f2195a4&scoped=true&ts=true"
import script from "./modal-bottom.vue?vue&type=script&lang=ts"
export * from "./modal-bottom.vue?vue&type=script&lang=ts"

import "./modal-bottom.scss?vue&type=style&index=0&id=3f2195a4&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2195a4"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField});
